import type { TourConfig } from '@components/tours/types';

export const planboardOverviewTour: TourConfig = {
  id: 'planboard-overview',
  name: 'Planboard Overview',
  description: 'Learn how to use the planboard to manage production operations',
  steps: [
    {
      tourId: 'planboard-columns-overview',
      popover: {
        title: 'Planboard Layout',
        description: 'The planboard shows your production operations organized by machine. Each column represents a machine with its scheduled jobs.',
      },
    },
    {
      tourId: 'planboard-no-machine-column',
      popover: {
        title: 'Unassigned Operations',
        description: 'The "No Machine" column contains operations not yet assigned to a machine. Use the filter tabs to switch between "All Operations" and "Linked Operations".',
      },
    },
    {
      tourId: 'planboard-machine-column',
      popover: {
        title: 'Machine Columns',
        description: 'Each machine column shows scheduled operations with an efficiency chart at the top. Operations are ordered by scheduled start date.',
      },
    },
    {
      tourId: 'planboard-card-footer',
      popover: {
        title: 'Click to Navigate',
        description: 'Click on any card\'s footer area to navigate to the job details. For running jobs, this opens the batch view.',
      },
    },
    {
      tourId: 'planboard-card-days-badge',
      popover: {
        title: 'Priority & Scheduling',
        description: 'The colored badge shows days until scheduled start. Click it to view priority adjustment options. Arrows indicate manual priority overrides.',
      },
    },
  ],
};
